import sortBy from 'lodash/sortBy'
import findIndex from 'lodash/findIndex'

export default function (state = [], action) {
	switch (action.type) {

	case 'FETCH_ARCHIVED_SECTIONS_SUCCESS':
		return action.response


	case 'ARCHIVE_SECTION_SUCCESS':
		const newArray= [...state,action.response]
		const sortedNewArray=sortBy(newArray, [function(section) { 		
			return section.name.toString().toLowerCase()
		}])
		return sortedNewArray



	case 'UNARCHIVE_SECTION_SUCCESS':
		const unarchivedSectionId = action.response.id
		//find index of the section we updated
		var indexOfSectionToUnArchive = findIndex(state,section => {
			return section.id === unarchivedSectionId
		})		

		return [
			...state.slice(0,indexOfSectionToUnArchive),
			...state.slice(indexOfSectionToUnArchive + 1)
		]




	case 'DELETE_SECTION_SUCCESS':
		const sectionId = action.sectionId
		//find index of the section we deleted
		const indexOfSectionToDelete = state.findIndex(section => {
			return section.id === sectionId
		})
		return [
			// from the start to the one we want to delete
			...state.slice(0,indexOfSectionToDelete),
			// after the deleted one, to the end
			...state.slice(indexOfSectionToDelete + 1)
		]

	case 'LOGOUT':
		return []
	
	default:
		return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/archivedSections.js